<template>
    <div class="row" style="padding:0px; margin-top:16px;" v-if="accountInfoLoaded">
        <div class="col-sm-12">
            <h2 >{{ t('clients.subscription.payment_plan') }}</h2>
            <div class="stroke col-sm-12" style=" display: flex; margin-top:16px;">
                <div class="col-sm-2">
                    <div style="display: flex">
                        <i class="fal" :class="icon" :style="{color: iconColor}"></i>
                        <span style="padding-left: 4px;">{{t(`clients.company.subscription.type.${accountInfo.type.type}`)}}</span>
                    </div>
                    <div v-if='accountInfo.payment_interval' style="display: block; font-size: 12px; margin-top: 5px;">{{t(`clients.company.subscription.payment_interval`)}}: {{t(`clients.company.subscription.payment_interval.${accountInfo.payment_interval}`)}}</div>
                    <div v-else style="display: block; font-size: 12px; margin-top: 5px;">{{t(`clients.company.subscription.payment_interval`)}}: {{t(`clients.company.subscription.payment_interval.free`)}}</div>
                </div>
                <div class="col-sm grey-bg" style="display:flex;">
                    <div class="icon" style="width:10%;"><i class="fal fa-clock"></i></div>
                    <div class="timespan-stroke" style="width:50%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">
                        <div class="temp-stroke" style="height:3px; position:absolute;" :style="{width: `${calulateProgressbarDays}%`, backgroundColor: calulateProgressbarDaysColor}"></div>
                    </div>
                    <div class="days-remaining" style="width:40%; text-align:center;" v-tooltip.bottom="`${t('tooltip.subscription_valid_until')} ${accountInfo.subscribed_till_formatted}`">
                        <span v-if="calulateRemainingDays !== false && calulateRemainingDays > 0"> {{calulateRemainingDays}} {{t('clients.subscription.days_valid')}} </span>
                        <span  v-if="calulateRemainingDays === false">{{t('clients.company.subscription.type.free')}} </span>
                        <span  v-if="calulateRemainingDays === 0">{{t('clients.subscription.valid_till_today')}} </span>
                        <span  v-if="calulateRemainingDays === -1">{{t('clients.subscription.expired')}} </span>
                    </div>
                </div>
                <div class="col-sm grey-bg" style="display:flex;">
                    <div class="icon" style="width:10%;"><i class="fal fa-boxes"></i></div>
                    <div class="timespan-stroke" style="width:50%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">
                        <div class="temp-stroke" style="height:3px; position:absolute;" :style="{width: `${calulateProgressbarProducts}%`, backgroundColor: calulateProgressbarProductsColor}"></div>
                    </div>
                    <div class="days-remaining" style="width:40%; text-align:right;">{{calulateRemainingProducts}}</div>
                </div>
                <div @click="$router.push({ name: 'Client Company Subscription' })" class="col-sm-2" style="align-items: center; display: flex; cursor:pointer;"><i class="fal fa-external-link-square" ></i><span style="padding-left: 4px;">{{t('clients.subscription.update_payment_plan')}}</span></div>
            </div>
        </div>
    </div>
</template>
<script>
import { get } from '@/helpers/http';
import { getUser } from '@/helpers/auth';
import handleError from '@/helpers/error';

export default {
    name: 'AccountSubscriptionInformation',

    data() {
        return {
            accountInfo: {},
            accountInfoLoaded: false,

            statistics: {},
        };
    },

    created() {
        this.getAccountInfo();
        this.getStatistics();
    },

    methods: {
        getAccountInfo() {
            this.accountInfoLoaded = false;

            const user = getUser();
            this.accountInfo = user.client.subscription;
            this.accountInfoLoaded = true;
        },

        getStatistics() {
            get({
                url: `${this.$API_URL}/api/clients/statistics`,
            })
                .then((response) => {
                    this.statistics = response.data;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },


    },

    computed: {
        calulateRemainingDays() {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const today = new Date();
            const account = this.accountInfo;

            if (account.subscribed_till === null) {
                return false;
            }

            const firstDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const secondDate = new Date(account.subscribed_till);

            const diffDays = Math.round((secondDate - firstDate) / oneDay);

            if (diffDays < 0) {
                return -1;
            }

            return diffDays;
        },

        calulateRemainingProducts() {
            const statistics = this.statistics;

            const totalproducts = this.accountInfo.type.max_sync;

            return `${statistics.product_amount} / ${totalproducts}`;
        },

        calulateProgressbarProducts() {
            // const account = this.accountInfo;
            const statistics = this.statistics;

            const totalproducts = this.accountInfo.type.max_sync;

            const percentage = statistics.product_amount / totalproducts * 100;

            if (percentage > 100) {
                return 100;
            }

            return percentage;
        },

        calulateProgressbarProductsColor() {
            const test = this.calulateProgressbarProducts;
            let color = '';
            if (test <= 100 && test >= 60) {
                color = 'red';
            } else if (test <= 59 && test >= 30) {
                color = 'orange';
            } else {
                color = 'green';
            }
            return color;
        },

        calulateProgressbarDays() {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const today = new Date();
            const account = this.accountInfo;

            const firstDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const secondDate = new Date(account.subscribed_till);

            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            let finalpercentage = 0;
            if (account.type.type === 'yearly') {
                const percentage = diffDays / 365 * 100;
                finalpercentage = 100 - percentage;
            } else if (account.type.type === 'once') {
                const percentage = diffDays / 8 * 100;
                finalpercentage = 100 - percentage;
            } else {
                // Free trial
                const percentage = diffDays / 8 * 100;
                finalpercentage = 100 - percentage;
            }

            if (finalpercentage > 100) {
                return 100;
            }

            return finalpercentage;
        },

        calulateProgressbarDaysColor() {
            const test = this.calulateProgressbarDays;
            let color = '';
            if (test <= 100 && test >= 60) {
                color = 'red';
            } else if (test <= 59 && test >= 30) {
                color = 'orange';
            } else {
                color = 'green';
            }
            return color;
        },

        icon() {
            let icon = '';
            if (this.accountInfo.type.type === 'yearly') {
                icon = 'fa-gem';
            } else if (this.accountInfo.type.type === 'once') {
                icon = 'fa-peace';
            } else {
                icon = 'fa-heart';
            }
            return icon;
        },

        iconColor() {
            let iconColor = '';
            if (this.accountInfo.type.type === 'yearly') {
                iconColor = '#FECB18';
            } else if (this.accountInfo.type.type === 'once') {
                iconColor = '#86DEB7';
            } else {
                iconColor = '#F879C3';
            }
            return iconColor;
        },
    },
};
</script>
<style lang="scss" scoped>
.stroke {
    background-color: white;
    padding: 8px;
    border-radius: 5px;
}

.grey-bg {
    background-color: $bluegrey;
    padding: 10px;
    margin-right:8px;
    border-radius: 5px;
}
</style>
